export default __webpack_public_path__ + "static/media/waist_navel.c1f46755.svg";